import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const ttmlFunc = _ttmlFunc;

/* Paramount IMSC 1.1 Text Profile delivery spec: media time base, hh:mm:ss.nnn times, fontSize 100%, */
/* and two fixed regions spanning the 10% safe area (before = top-aligned, after = bottom-aligned). */
export default {
  decode: function (input, options) {
    throw new Error("Decoding the Paramount IMSC 1.1 profile is not supported. Please use the IMSC 1.1 Text Profile for decoding or contact support.");
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    let frameRateMultiplier = ttmlFunc.frameRateMultiplierMap[options.frameRate];
    let windowHeight = options.window?.height || 15;
    let output = eol.after(`<?xml version="1.0" encoding="UTF-8"?>`);
    output += eol.after(`<tt xml:lang="${encodingOptions["Language Code"] || "en-US"}" xmlns="http://www.w3.org/ns/ttml" xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:ttp="http://www.w3.org/ns/ttml#parameter" xmlns:ttm="http://www.w3.org/ns/ttml#metadata" xmlns:itts="http://www.w3.org/ns/ttml/profile/imsc1#styling" ttp:frameRate="${ttmlFunc.frameRateMap[options.frameRate] ?? Math.round(options.frameRate)}" ttp:frameRateMultiplier="${frameRateMultiplier}" ttp:contentProfiles="http://www.w3.org/ns/ttml/profile/imsc1.1/text" ttp:timeBase="media">`);
    output += eol.after(`  <head>`);
    output += eol.after(`    <metadata/>`);
    output += eol.after(`    <styling>`);
    output += eol.after(`      <style xml:id="style.center" tts:fontFamily="${encodingOptions["Font Family"] || "proportionalSansSerif"}" tts:fontSize="100%" tts:fontStyle="normal" tts:fontWeight="normal" tts:backgroundColor="transparent" tts:color="white" tts:textAlign="center"/>`);
    output += eol.after(`    </styling>`);
    output += eol.after(`    <layout>`);
    output += eol.after(`      <region xml:id="region.after" tts:displayAlign="after" tts:backgroundColor="transparent" tts:origin="10% 10%" tts:extent="80% 80%"/>`);
    output += eol.after(`      <region xml:id="region.before" tts:displayAlign="before" tts:backgroundColor="transparent" tts:origin="10% 10%" tts:extent="80% 80%"/>`);
    output += eol.after(`    </layout>`);
    output += eol.after(`  </head>`);
    output += eol.after(`  <body>`);
    output += eol.after(`    <div>`);
    eventGroup.events.forEach(event => {
      let start = tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame).replace(",", ".");
      let end = tcLib.secToTcMs(event.end, options.frameRate, options.dropFrame).replace(",", ".");
      let lineNumber = parseInt(event.yPos, 10);
      let region = event.yPos === "start" || !isNaN(lineNumber) && lineNumber < windowHeight / 2 ? "region.before" : "region.after";
      let plainTextCustom = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", true);
      let ttmlText = ttmlFunc.multiLine.convertToTtml(plainTextCustom);
      output += eol.after(`      <p style="style.center" region="${region}" begin="${start}" end="${end}"${ttmlFunc.forcedDisplayAttr(event)}>${ttmlText}</p>`);
    });
    output += eol.after(`    </div>`);
    output += eol.after(`  </body>`);
    output += `</tt>`;
    return eol.auto(output);
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input);
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};